<template>
  <div class="m-n3">
    <div class="container section">
      <div class="row">
        <div class="col-9 py-4">
          <h3 class="section-title pt-0">
            Tárgyak tesztelésre - {{ tests.length }} variáció
          </h3>
          <div class="section-content">
            <div class="px-3 py-2">
              <div
                v-for="(line, num) in testLines"
                :key="num"
                class="d-flex flex-row"
              >
                <span class="label p-2 pr-4"><b>{{ line.label }}</b></span>
                <span class="subject flex-grow-1 align-self-center pr-2"><b>{{ line.subject }}</b></span>
                <span
                  class="action text-right align-self-center"
                  @click="copy(line.subject)"
                >
                  <i class="far fa-copy" />
                </span>
              </div>
            </div>
            <div class="section-divider" />
            <div class="px-3 pb-2 row">
              <b-form-group
                :state="dispatchedAtState"
                class="col"
                label-class="text-uppercase"
                label="Dátum"
                label-for="dispatched_at-input"
                :invalid-feedback="errors$dispatched_at"
              >
                <date-picker
                  v-model="dispatched_at"
                  :state="dispatchedAtState"
                  :input="{id: 'dispatched_at-input'}"
                />
              </b-form-group>
            </div>
            <div class="px-3 pb-2 row">
              <b-form-group
                :state="errors$name.length === 0"
                class="col-6"
                label-class="text-uppercase"
                label="Kampánynév"
                label-for="name-input"
                :invalid-feedback="errors$name"
              >
                <b-form-input
                  id="name-input"
                  v-model="name"
                  :state="errors$name.length === 0"
                  required
                />
              </b-form-group>
              <b-form-group
                :state="segments.length < 1 ? null : errors$segments.length === 0"
                class="col-6"
                label-class="text-uppercase"
                label="Szegmensek"
                label-for="segments-input"
                :invalid-feedback="errors$segments"
              >
                <segment-select
                  :segments.sync="segments"
                  :state="segments.length < 1 ? null : errors$segments.length === 0"
                  :input="{id: 'segments-input'}"
                />
              </b-form-group>
              <div class="mx-auto mt-3">
                <b-button
                  variant="info"
                  :disabled="!validForm"
                  @click="save"
                >
                  <span>Kampány véglegesítése</span>
                  <i class="fas fa-caret-right" />
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3 py-3 pr-3">
          <small>Fontos, hogy a kampányok időzítve, pontosan egy időben kerüljenek kiküldésre. A tárgy mezőn kívül semmilyen egyéb eltérés nem lehet a levelek között, így tudjuk csak biztosítani a pontos mérhetőséget. A tárgyakat a véglegesítés után már ne változtasd, ha szükséges inkább másold le módosítsd a kampányt újként.</small>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  h3 {
    text-transform: uppercase;
  }
  .label {
    text-transform: uppercase;
    font-size: 120%;
    color: var(--lingusta-green);
  }
  .action {
    cursor: pointer;
    font-size: 120%;
  }
</style>
<script>
import { computeTestLabel, sortTests } from '../../util'
import SegmentSelect from '../segment/SegmentSelect'
import DatePicker from '../common/DateTimePicker'
import FormValidation from '../../utils/mixins/FormValidation'
import ErrorHandler from '../../utils/mixins/ErrorHandler'

export default {
  components: {
    SegmentSelect,
    DatePicker
  },
  mixins: [
    FormValidation(['name', 'dispatched_at', 'segments']),
    ErrorHandler()
  ],
  props: {
    testCampaign: {
      type: Object,
      required: true
    },
    espId: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      id: -1,
      name: '',
      dispatched_at: '',
      segments: [{
        id: -1,
        name: ''
      }],
      tests: []
    }
  },
  computed: {
    dispatchedAtState() {
      return this.dispatched_at.length > 0 ? this.errors$dispatched_at.length === 0 : null
    },
    validForm() {
      return this.errors$name.length === 0 && this.errors$dispatched_at.length === 0 && this.errors$segments.length === 0
    },
    testLines() {
      var tests = this.tests
      sortTests(tests)

      return _.map(tests, (test, index) => ({
        ...test,
        label: computeTestLabel(index, tests.length),
      }))
    },
  },
  watch: {
    name(name) {
      if(name.length < 1) {
        this.errors$name = 'A kampánynév megadása kötelező'
      } else {
        this.errors$name = ''
      }
    },
    testCampaign: {
      deep: true,
      immediate: true,
      handler(testcampaign) {
        _.forEach(testcampaign, (value, key) => {
          if(typeof this[key] !== undefined) {
            this[key] = value
          }
        })
      }
    }
  },
  mounted() {

  },
  methods: {
    save() {
      this.clearErrors()

      this.$http.patch(this.$url('api.test-campaigns.update', this.id), {
        'dispatched_at': this.dispatched_at,
        'segments': _.map(this.segments, (segment) => {
          return typeof segment.new !== 'undefined' ? _.omit(segment, 'id') : segment
        }),
        'name': this.name
      }).then(() => {
        window.location = this.$url('test-campaigns.index')
      }).catch(this.handleErrors)
    },
    copy(value) {
      this.$copyText(value).then(() => {
        this.$bvToast.toast(`"${value}" a vágólapra másolva`, {
          title: 'Tárgy tesztelése',
          autoHideDelay: 2000,
          appendToast: true
        })
      }, () => {
        this.$bvToast.toast(`Nem sikerült a vágólapra másolni: "${value}"`, {
          title: 'Tárgy tesztelése',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
      })
    }
  }
}
</script>